import React from 'react'
import Button from "../../components/Template/Button"
import styled, { ITheme } from "../../theme"
import { useTranslation } from "react-i18next"
import { FiX } from 'react-icons/fi'
import { Mixpanel } from '../../utils/Mixpanel'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'
import { useDispatch, useSelector } from 'react-redux'
import { getAccessToken } from '../../reducers/userAccount/selectors/credentials'
import useIsScope from '../../hooks/useIsScope'
import { PermissionScope } from '../../containers/Employees'
import { fireToastError } from '../../actions/toasts/fireToast'

const Wrapper = styled.div`
    background-color: #F3F5F6;
    width: 100%;
    display: flex;
    justify-content: center;

    padding-top: 146px;
    @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
        padding-top: 0;
        align-items: center;
    }
`

const Wrapper2 = styled.div`
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 12px 24px 24px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    padding-top: 0;
    align-items: center;
  }
`

const Title = styled.div`
    color: #000;
    margin-bottom: 8px;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 157.143% */
    letter-spacing: 0.028px;
`

const Subtitle = styled.div`
    color: #000;

    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 163.636% */
    letter-spacing: 0.022px;
    margin-bottom: 32px;
`

export function UpgradePremiumPopover({handleClose}: any) {
  const {t} = useTranslation()
  const key = useSelector(getAccessToken)
  const dispatch = useDispatch()
  const goToPremium = () => {
    if (!scopes.premium) {
      dispatch(fireToastError(t('BED_3621_no_permission')))
    } else {
      Mixpanel.track('Premium Active Screen Extend Access', {})
      //var EnvUrl = getApiUrlForEnv()
      window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
    }
  }

  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })

  return (
    <Wrapper2>
      <div style={{width: '100%', cursor:'pointer', display:'flex',paddingBottom:'12px', justifyContent:'flex-end'}}>
        <FiX onClick={handleClose}/>
      </div>
      <div>
        <Title><span aria-label={'lock'} role={'img'}>🔒</span> {t('new_premium_access_denied_screen_header')}</Title>
        <Subtitle>{t('new_premium_access_denied_screen_text')}</Subtitle>
        <div>
          <Button
            borderRadius={6}
            primary={true}
            onClick={goToPremium}
            disabled={!scopes.premium}
          >{t('new_premium_access_denied_screen_button_text')}</Button>
        </div>
      </div>
    </Wrapper2>
  )
}

function UpgradePremium() {
  const {t} = useTranslation()
  const key = useSelector(getAccessToken)
  const dispatch = useDispatch()
  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })
  const goToPremium = () => {
    if (!scopes.premium) {
      dispatch(fireToastError(t('BED_3621_no_permission')))
    } else {
      Mixpanel.track('Premium Active Screen Extend Access', {})
      //var EnvUrl = getApiUrlForEnv()
      window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
    }
  }

 return (
   <Wrapper>
     <div>
       <Title><span aria-label={'lock'} role={'img'}>🔒</span> {t('new_premium_access_denied_screen_header')}</Title>
     <Subtitle>{t('new_premium_access_denied_screen_text')}</Subtitle>
       <div>
     <Button
       borderRadius={6}
       primary={true}
       onClick={goToPremium}
       disabled={!scopes.premium}
       >{t('new_premium_access_denied_screen_button_text')}</Button>
       </div>
     </div>
   </Wrapper>
 );
};

export interface IUpgradePremium {

}

export default UpgradePremium
